import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

export type SortType = 'most' | 'recent' | 'latestCreation';

interface GetFileBulkClientTrackListRequest {
  fileId: number;
  sort: SortType;
}

export interface BulkTrackClient {
  name: string;
  email: string;
  readCount: number;
  lastAction: string;
  isChecked: boolean;
  isBlurred: boolean;
}

export interface GetFileBulkClientTrackListResponse {
  clients: BulkTrackClient[];
}

export const getFileBulkClientTrackList = ({
  fileId,
  sort,
}: GetFileBulkClientTrackListRequest) => {
  return api.get<ApiResponse<GetFileBulkClientTrackListResponse>>(
    `/file/bulk/client/track/list`,
    {
      params: { fileId, sort },
    },
  );
};

const useFileBulkClientTrackList = <
  TData = AxiosResponse<ApiResponse<GetFileBulkClientTrackListResponse>>,
  TError = AxiosError<ApiErrorResponse>,
>(
  request: GetFileBulkClientTrackListRequest,
  options?: UseQueryOptions<
    AxiosResponse<ApiResponse<GetFileBulkClientTrackListResponse>>,
    TError,
    TData,
    ['getFileBulkClientTrackList', GetFileBulkClientTrackListRequest]
  >,
): UseQueryResult<TData, TError> => {
  return useQuery(
    ['getFileBulkClientTrackList', request],
    () => getFileBulkClientTrackList(request),
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  );
};

export default useFileBulkClientTrackList;
